import { h } from '../dom.js';
import { t } from '../../i18n/index.js';

/**
 * The NightBand wordmark as an image (the mandatory transparent logo asset). Decorative — the
 * accessible name comes from a sibling text node or the alt passed in — so callers control whether
 * it announces. Purely presentational: it never changes what the surrounding control does.
 */
export function brandLogo(className = '', alt = ''): HTMLImageElement {
  return h('img', {
    class: `nb-logo ${className}`.trim(),
    src: '/brand/nightband-logo.png',
    alt,
    ...(alt ? {} : { 'aria-hidden': 'true' }),
    decoding: 'async',
  }) as HTMLImageElement;
}

/** The GADDAR studio emblem. Decorative by default. */
export function studioLogo(className = '', alt = ''): HTMLImageElement {
  return h('img', {
    class: `nb-studio-logo ${className}`.trim(),
    src: '/brand/gaddar.png',
    alt,
    ...(alt ? {} : { 'aria-hidden': 'true' }),
    decoding: 'async',
  }) as HTMLImageElement;
}

/** The site footer: the legal pages are plain links — server-rendered, JS-independent. */
export function footer(): HTMLElement {
  return h(
    'footer',
    { class: 'nb-footer' },
    h(
      'div',
      { class: 'nb-footer__brand' },
      studioLogo('nb-footer__studio', t('landing.studio.name')),
      h(
        'div',
        { class: 'nb-footer__lines' },
        h('span', { class: 'nb-footer__mark', text: t('app.name') }),
        h('span', {
          class: 'nb-footer__tagline',
          text: `${t('landing.studio.name')} · ${t('landing.footer.tagline')}`,
        }),
      ),
    ),
    h(
      'nav',
      { class: 'nb-footer__nav', 'aria-label': t('app.name') },
      h('a', { href: '/terms', text: t('nav.terms') }),
      h('a', { href: '/privacy', text: t('nav.privacy') }),
      h('a', { href: 'mailto:contact@deshretmaat.com', text: t('nav.contact') }),
    ),
  );
}

/** Display header with the "fractured type" treatment — a ghost copy sheared behind the word. */
export function glitchTitle(text: string, className = ''): HTMLElement {
  return h(
    'h1',
    { class: `nb-glitch ${className}`.trim(), dataset: { text } },
    h('span', { class: 'nb-glitch__base', text }),
  );
}

export function banner(kind: 'alert' | 'note', message: string): HTMLElement {
  return h('p', {
    class: `nb-banner nb-banner--${kind}`,
    role: kind === 'alert' ? 'alert' : 'status',
    text: message,
  });
}
